export function nativeAsync(target, method, descriptor) {
  const originalMethod = target[method];
  descriptor.value = function() {
    return Promise.resolve(originalMethod.apply(this, arguments));
  };
}
